import { Rightsholder } from '@app/types/api';

const getPlacementName = (
    rightsholderPlacementIds: Array<string>,
    rh: Rightsholder | undefined,
) => {
    if (!rh?.rightsholderPlacements) return [];
    const rhPlacements = rh.rightsholderPlacements;
    const placementNames = rightsholderPlacementIds.map(p => {
        const [, shortenedPlacementId] = p.split('-');
        const currPlacement = rhPlacements.find(
            pl => pl.id === parseInt(shortenedPlacementId),
        );
        return currPlacement?.name;
    });
    return placementNames;
};

export default getPlacementName;
